import { ChangeEvent, ReactElement, useState } from "react";
import { IDelayMeltShop, ILRFProduction, IProductionExtended, IState } from "../../../types";
import { Paper, Tab, Tabs } from "@mui/material";
import DelayPanel from "../../interruptions/compoenents/delayPanel";
import TabPanel from "../../../components/tabPanel";
import { useSelector } from "react-redux";
import LRFGeneralPanel from "./lrfGeneralPanel";
import EquipmentLifePanel from "./equipmentLifePanel";
import NotePanel from "./notesPanel";
import ConsumptionPanel from "./consumptionPanel";
import StepPanel from "./stepPanel";
import TemperaturePanel from "./temperaturePanel";
import SlagChemistryPanel from "./slagChemistryPanel";
import HeatChart from "../../production/components/heatChart";
import SamplePanel from "../../production/components/heatPanels/samplesPanel";

interface IHeatInformationProps {
  productionItem: IProductionExtended;
  height?: number;
}

const LRFHeatInformation = ({ productionItem, height }: IHeatInformationProps): ReactElement => {
  const darkMode = useSelector((state: IState) => state.darkMode);
  const [value, setValue] = useState(0);
  const [selectedDelay, setSelectedDelay] = useState<IDelayMeltShop | null>(null);

  const handleChange = (_event: ChangeEvent<any>, newValue: number) => {
    setValue(newValue);
  };

  const heatData = productionItem as ILRFProduction;


  return (
    <Paper style={{ height }}>
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        centered={true}
        style={{ background: darkMode ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.2)" }}>
        <Tab label="General"/>
        <Tab label="Samples"/>
        <Tab label="Slag Chemistry"/>
        {/*<Tab label="Alloys"/>*/}
        <Tab label="Delays"/>
        <Tab label="Step Data"/>
        <Tab label="Temperature Summary"/>
        <Tab label="Consumption Summary"/>
        <Tab label="Equipment Life"/>
        <Tab label="Notes"/>
      </Tabs>
      <TabPanel value={value} index={0} style={{ padding: "1em" }}>
        <LRFGeneralPanel productionItem={productionItem}/>

        <div style={{ width: "100%", height: 100, marginTop: "1em" }}>
          <HeatChart productionData={productionItem} hideAxisTitle={true} selected={selectedDelay}/>
        </div>
      </TabPanel>

      <TabPanel value={value} index={1}>
        <SamplePanel samples={productionItem.samples.filter(x => !x.sampleType.code.startsWith("LT"))} steelCode={heatData.steel.code} zoneCode={productionItem.zone.code}/>
      </TabPanel>

      <TabPanel index={value} value={2}>
        <SlagChemistryPanel data={productionItem.samples}/>
      </TabPanel>


      {/*<TabPanel value={value} index={1}>*/}
      {/*  <AdditionPanel additions={heatData.additions} sourceType={0}/>*/}
      {/*</TabPanel>*/}
      <TabPanel value={value} index={3}>
        <DelayPanel delays={productionItem.delays as IDelayMeltShop[]} selected={selectedDelay} setSelected={d => setSelectedDelay(d as IDelayMeltShop)} />
      </TabPanel>

      <TabPanel value={value} index={4}>
        <StepPanel data={heatData.stepHistory} />
      </TabPanel>

      <TabPanel value={value} index={5}>
        <TemperaturePanel data={heatData.samples.filter(x => x.sampleType.code.startsWith("LT"))} />
      </TabPanel>

      <TabPanel value={value} index={6}>
        <ConsumptionPanel data={heatData.consumptionSummary} />
      </TabPanel>

      <TabPanel value={value} index={7}>
        <EquipmentLifePanel data={heatData.equipmentLife} />
      </TabPanel>

      <TabPanel value={value} index={8}>
        <NotePanel data={heatData.notes} />
      </TabPanel>
    </Paper>
  );
};

export default LRFHeatInformation;
